import { useTranslation } from 'react-i18next';
import { SectionStore } from '~/stores/sections';
import Widget, { MetricWidgetOption } from '~components/Atoms/Widget';
import WidgetSection from '~components/Molecules/WidgetSection';
import GridWidgetSection from '~components/Molecules/GridWidgetSection';
import { useCurrentLanguage } from '~hooks/language';
import { IntelliProveWidgetsProvider } from '~providers/widgets';
import { getAuthFromSearchParams } from '~utils/path/search_params';
const APIURL = import.meta.env.VITE_API_URL;

function HealthDashboardPage() {
  const { t } = useTranslation();
  const [authKey] = getAuthFromSearchParams();
  const currentLanguage = useCurrentLanguage();

  const { metricsEnabled, recommendationsEnabled, mainEnabled, todosEnabled } = SectionStore();

  const metrics: Array<MetricWidgetOption> = [
    'mental_stress',
    'mental_health_risk',
    'general_fitness',
    'sleep_quality',
    'energy_balance',
    'hypertension_risk',
  ];

  return (
    <IntelliProveWidgetsProvider actionToken={authKey} apiurl={APIURL} locale={currentLanguage}>
      <main className="py-8 max-w-[1320px] mx-auto my-0">
        {mainEnabled && (
          <WidgetSection title={t('section_title_main')}>
            <ip-session className="h-fit flex flex-col gap-4 items-stretch w-full" language={currentLanguage} action-token={authKey}>
              <ip-main-widget></ip-main-widget>
            </ip-session>
          </WidgetSection>
        )}

        {metricsEnabled && (
          <GridWidgetSection title={t('section_title_insights')} info={t('section_info_insights')}>
            {metrics.map((m, i) => (
              <Widget kind="metric" key={i} elementId={`metric-${i}`} config={{ parameter: m }} className="w-[288px] h-[480px]" />
            ))}
          </GridWidgetSection>
        )}

        {(recommendationsEnabled || todosEnabled) && (
          <WidgetSection title={t('section_title_recommendations')}>
            {recommendationsEnabled && (
              <Widget kind="recommendations" elementId="recommendations-1" config={{}} className="w-full min-w-[300px]" />
            )}
            {todosEnabled && <Widget kind="todos" elementId="todos-1" config={{}} className="w-full min-w-[300px]" />}
          </WidgetSection>
        )}
      </main>

      <footer className="mx-auto pb-12 w-full px-8">
        <small className="max-w-[1320px]">{t('footer_disclaimer')}</small>
      </footer>
    </IntelliProveWidgetsProvider>
  );
}

export default HealthDashboardPage;
